'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _components = require('../../components');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _caterwaulComponents = require('@liveauctioneers/caterwaul-components');

var _user = require('../../redux/modules/user');

var _noop = require('../../utils/noop');

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ItemPriceGatewayContainer = require('./ItemPriceGatewayContainer.scss');

var _ItemPriceGatewayContainer2 = _interopRequireDefault(_ItemPriceGatewayContainer);

var _saveItem = require('../../redux/modules/saveItem');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemPriceGatewayContainer = (_dec = (0, _reactRedux.connect)(function (state) {
    return {
        userAtLeastPartiallyRegistered: (0, _user.isUserAtLeastPartiallyRegistered)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({ toggleItemSave: _saveItem.toggleItemSave }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(ItemPriceGatewayContainer, _Component);

    function ItemPriceGatewayContainer() {
        (0, _classCallCheck3.default)(this, ItemPriceGatewayContainer);
        return (0, _possibleConstructorReturn3.default)(this, (ItemPriceGatewayContainer.__proto__ || (0, _getPrototypeOf2.default)(ItemPriceGatewayContainer)).apply(this, arguments));
    }

    (0, _createClass3.default)(ItemPriceGatewayContainer, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['userAtLeastPartiallyRegistered', 'children']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className,
                containerClassName = _props.containerClassName,
                itemCard = _props.itemCard,
                userAtLeastPartiallyRegistered = _props.userAtLeastPartiallyRegistered;


            var formattedMessageId = itemCard ? 'price_gateway_card' : 'price_gateway_item_page';
            var forceSignUp = !userAtLeastPartiallyRegistered;

            return (0, _jsx3.default)(_components.ShouldLogInContainer, {
                requireLogin: false,
                requireUserAtLeastPartiallyRegistered: true,
                runFunction: _noop2.default,
                className: className,
                forceSignUp: forceSignUp
            }, void 0, userAtLeastPartiallyRegistered ? children : (0, _jsx3.default)('span', {
                className: _ItemPriceGatewayContainer2.default['login-to-see-price'] + ' ' + containerClassName
            }, void 0, (0, _jsx3.default)(_components.Link, {
                className: _ItemPriceGatewayContainer2.default['icon-link']
            }, void 0, (0, _jsx3.default)('div', {
                className: _ItemPriceGatewayContainer2.default.oval
            }, void 0, (0, _jsx3.default)(_caterwaulComponents.Icon, {
                name: 'usd',
                className: _ItemPriceGatewayContainer2.default.icon
            }))), (0, _jsx3.default)(_components.Link, {
                className: _ItemPriceGatewayContainer2.default.link
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                className: _ItemPriceGatewayContainer2.default.link,
                id: formattedMessageId
            }))));
        }
    }]);
    return ItemPriceGatewayContainer;
}(_react.Component), _class2.defaultProps = {
    className: '',
    containerClassName: '',
    itemCard: false,
    userAtLeastPartiallyRegistered: false
}, _temp)) || _class);
exports.default = ItemPriceGatewayContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemPriceGateway/ItemPriceGatewayContainer.js
// module id = zfVU
// module chunks = 46